<script setup lang="ts">
/**
 * Logo, Slogan, Pictures and first Impressions
 * Short overview about services
 * Call-to-action button: Book your appointment
 *
 * TODO: View should start at the Beginning when switching pages
 *
 * --add Logo
 */

import {onBeforeUnmount, onMounted} from "vue";
import {Calendar, CarFront, Check, Hammer, NotebookText, Phone, Smartphone} from "lucide-vue-next";
import '@/assets/styles/home.css';

let observer: IntersectionObserver | null = null;

onMounted(() => {
  const elements = document.querySelectorAll(".animate-on-scroll");

  observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer?.unobserve(entry.target);
          }
        });
      },
      {threshold: 0.18}
  );

  elements.forEach((element) => observer?.observe(element));
});

onBeforeUnmount(() => {
  observer?.disconnect();
});
</script>

<template>
  <div class="home">
    <section class="layout hero">
      <div class="overlay">
        <div class="hero-content">
          <span class="hero-kicker">Demo-Website · KFZ Musterwerkstatt</span>
          <h1>Ihre KFZ-Werkstatt für Qualität, Sicherheit und Vertrauen</h1>
          <p>Ob Inspektion, Reparatur oder spezialisierte Serviceleistungen – bei uns ist Ihr Fahrzeug in besten Händen.
            Wir stehen für zuverlässige Arbeit, transparente Preise und moderne Technik. Unser Ziel: Sie schnell, sicher
            und sorgenfrei wieder auf die Straße zu bringen.
          </p>
          <div class="hero-buttons">
            <router-link to="/contact" class="appointment-button">
              <Calendar/>
              <span>Buchen Sie Ihren Termin</span>
            </router-link>

            <a href="tel:+491234567890" class="call-button">
              <Phone/>
              Anrufen
            </a>
            <a
                href="https://wa.me/491234567890?text=Hallo%20ich%20möchte%20einen%20Termin%20vereinbaren"
                target="_blank"
                rel="noopener"
                class="whatsapp-btn"
            >
              <Smartphone/>
              Termin über WhatsApp vereinbaren
            </a>
          </div>
        </div>
      </div>
    </section>
    <section class="layout features">
      <div class="card feature-box animate-on-scroll">
        <NotebookText/>
        <router-link to="/services" class="sides-link">
          <h2>Inspektion und Wartung</h2>
        </router-link>
        <p>
          Regelmäßige Wartung ist entscheidend für die Lebensdauer Ihres Fahrzeugs. Wir führen Inspektionen nach
          Herstellervorgaben durch, wechseln Öl und Flüssigkeiten und prüfen alle sicherheitsrelevanten Komponenten. So
          vermeiden Sie teure Folgeschäden und bleiben jederzeit mobil.
        </p>

      </div>
      <div class="card feature-box animate-on-scroll">
        <Hammer/>
        <router-link to="/services" class="sides-link">
          <h2>Reparaturen und Fahrzeugdiagnose</h2>
        </router-link>
        <p>
          Ob Motor, Getriebe oder Elektronik – wir finden die Ursache und kümmern uns darum, dass Ihr Fahrzeug wieder
          zuverlässig läuft. Mithilfe moderner Diagnosetechnik lassen sich Fehler gezielt eingrenzen, sodass unnötige
          Arbeiten vermieden werden.

          Von kleineren Reparaturen bis hin zu umfangreicheren Instandsetzungen arbeiten wir sorgfältig, transparent und
          mit Blick auf das Wesentliche. Sie erhalten eine ehrliche Einschätzung, was sinnvoll ist – damit Ihr Fahrzeug
          schnell und ohne unnötige Kosten wieder einsatzbereit ist.
        </p>

      </div>
      <div class="card feature-box animate-on-scroll">
        <CarFront/>
        <router-link to="/services" class="sides-link">
          <h2>Spezialservices & Werterhalt</h2>
        </router-link>
        <p>
          Von Getriebeölspülungen über Klimaservice bis hin zum Austausch von Windschutzscheiben: Unsere
          Zusatzleistungen sorgen für mehr Komfort, Sicherheit und den langfristigen Werterhalt Ihres Fahrzeugs.
        </p>

      </div>
    </section>
    <section class="services-grid">
      <div class="full-width-card animate-on-scroll">
        <h3>Ihre Vorteile auf einen Blick</h3>
        <ul>
          <li>
            <Check class="icon"/>
            Fachgerechte Arbeit nach aktuellen Standards
          </li>
          <li>
            <Check class="icon"/>
            Moderne Diagnose- und Werkstatttechnik
          </li>
          <li>
            <Check class="icon"/>
            Transparente Beratung und faire Preise
          </li>
          <li>
            <Check class="icon"/>
            Schnelle Terminvergabe und zuverlässiger Service
          </li>
        </ul>
      </div>
    </section>
    <section class="about-contact">
      <div class="contact-left animate-on-scroll">
        <div class="ueberuns">
          <div class="header">
            <router-link to="/about#about-view" class="sides-link">
              <h2>Über uns</h2>
            </router-link>
          </div>
          <div class="about-info">
            <p>
              KFZ Musterwerkstatt steht für zuverlässige Kfz-Reparaturen,
              kompetente Beratung und ehrlichen Service. Mit moderner Technik
              und langjähriger Erfahrung sorgen wir dafür, dass Ihr Fahrzeug
              sicher, zuverlässig und schnell wieder auf die Straße kommt.
            </p>
          </div>
        </div>

        <div class="contact">
          <div class="header">
            <router-link to="/contact" class="sides-link">
              <h2>Kontakt</h2>
            </router-link>
          </div>
          <div class="contact-info">
            <p>KFZ Musterwerkstatt</p>
            <p>Musterstraße 12</p>
            <p>12345 Musterstadt</p>
            <p>Telefon: +49 (0)1234 567890</p>
            <p>E-Mail: info@musterwerkstatt.example</p>
          </div>


          <div class="header">
            <h3>Öffnungszeiten</h3>
          </div>
          <div class="contact-info">
            <p>Mo. - Fr. 08:00-17:00</p>
          </div>
        </div>
      </div>

      <div class="contact-right animate-on-scroll">
        <img src="../assets/images/oilservice.png" alt="Oil-service"/>
      </div>
    </section>
  </div>
</template>

<style scoped>

</style>
